import { Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';

import { BreakpointHelpers } from 'src/app/models/BreakpointHelpers';
import { DialogData } from 'src/app/models/DialogData';
import { DialogOptions } from 'src/app/models/Enums/DialogOptions';
import { DialogResults } from 'src/app/models/Enums/DialogResults';
import { BreakpointService } from 'src/app/services/breakpoint.service';

import { MaterialModule } from '../../modules/material/material.module';

@Component({
  selector: 'stine-dialog',
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
  standalone: true,
  imports: [CommonModule, MaterialModule],
})
export class DialogComponent implements OnInit {
  public currentScreenSize: string;
  public dialog = inject(MatDialog);
  public dialogRef = inject(MatDialogRef<DialogComponent>);
  private breakpointService = inject(BreakpointService);
  private destroyRef = inject(DestroyRef);

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  ngOnInit(): void {
    this.breakpointService.screenSize$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => (this.currentScreenSize = value));
  }
  public get smallScreenSize(): boolean {
    return (
      this.currentScreenSize ===
        BreakpointHelpers.displayNameMap.get(Breakpoints.Small) ||
      this.currentScreenSize ===
        BreakpointHelpers.displayNameMap.get(Breakpoints.XSmall) ||
      this.currentScreenSize ===
        BreakpointHelpers.displayNameMap.get(Breakpoints.Medium)
    );
  }

  public onClick(result: string): void {
    switch (result) {
      case 'cancel':
        this.dialogRef.close(DialogResults.Cancel);
        break;
      case 'confirm':
        this.dialogRef.close(DialogResults.Confirm);
        break;
      case 'delete':
        this.dialogRef.close(DialogResults.Delete);
        break;
      case 'ok':
        this.dialogRef.close(DialogResults.Ok);
        break;
      case 'stay':
        this.dialogRef.close(DialogResults.Stay);
        break;
      case 'logout':
        this.dialogRef.close(DialogResults.Logout);
        break;
    }
  }

  public showButton(name: string): boolean {
    switch (name) {
      case 'abort':
        return this.data.dialogOption === DialogOptions.AbortRetryIgnore;
      case 'cancel':
        return (
          this.data.dialogOption === DialogOptions.ConfirmCancel ||
          this.data.dialogOption === DialogOptions.DeleteCancel ||
          this.data.dialogOption === DialogOptions.DiscardCancel ||
          this.data.dialogOption === DialogOptions.OkCancel ||
          this.data.dialogOption === DialogOptions.RetryCancel ||
          this.data.dialogOption === DialogOptions.YesNoCancel
        );
      case 'confirm':
        return this.data.dialogOption === DialogOptions.ConfirmCancel;
      case 'delete':
        return this.data.dialogOption === DialogOptions.DeleteCancel;
      case 'discard':
        return this.data.dialogOption === DialogOptions.DiscardCancel;
      case 'ingore':
        return this.data.dialogOption === DialogOptions.AbortRetryIgnore;
      case 'no':
        return (
          this.data.dialogOption === DialogOptions.YesNo ||
          this.data.dialogOption === DialogOptions.YesNoCancel
        );
      case 'ok':
        return (
          this.data.dialogOption === DialogOptions.Ok ||
          this.data.dialogOption === DialogOptions.OkCancel
        );
      case 'retry':
        return (
          this.data.dialogOption === DialogOptions.AbortRetryIgnore ||
          this.data.dialogOption === DialogOptions.RetryCancel
        );
      case 'yes':
        return (
          this.data.dialogOption === DialogOptions.YesNo ||
          this.data.dialogOption === DialogOptions.YesNoCancel
        );
      case 'stay':
        return this.data.dialogOption === DialogOptions.StayLogout;
      case 'logout':
        return this.data.dialogOption === DialogOptions.StayLogout;
    }
  }
}
